import React from "react";
import styles from  "./missionValues.module.css"; 

const MissionValues = () => {
  const values = [
    { title: "Mission", description: "Providing quality education and modern facilities to empower rural students and foster community growth." , icon: '/icons/mission.png'},
    { title: "Empowerment", description: "Supporting underprivileged and rural students, including girls, to access education." , icon: '/icons/empowerment.png'},
    { title: "Inclusivity", description: "Ensuring equal opportunities for all students.", icon: '/icons/inclusivity.png' },
    { title: "Excellence", description: "Offering advanced facilities for enhanced learning.", icon: '/icons/excellence.png' },
    { title: "Community Growth", description: "Shaping students into responsible citizens driving village and societal progress.", icon: '/icons/community.png' },
  ];

  return (
    <div className={styles.cardsContainer}>
      {values.map((value, index) => (
        <div className={styles.card} key={index}>
            <img src={value.icon} alt={value.title}/>
          <h3>{value.title}</h3>
          <p>{value.description}</p>
        </div>
      ))}
    </div>
  );
};

export default MissionValues;
